import type { Policy } from '../types/site'

type Obj = Record<string, unknown>
const isObj = (v: unknown): v is Obj => typeof v === 'object' && v !== null && !Array.isArray(v)

/**
 * Een oudere opslag kent nieuwe instellingen nog niet (bijv. `kuurValidMonths`, `kuurTransferable`).
 * Vul elk ontbrekend veld aan met de standaard, ook in `subscription` en `consult`; wat er wél staat,
 * blijft staan. Zelfde idee als `upgradePageContent` voor de paginateksten. Een veld met een ander
 * soort waarde (bijv. `null` of tekst waar een getal hoort) telt als ontbrekend, zodat een schakelaar
 * of getalveld nooit zonder waarde komt te staan.
 */
export function withPolicyDefaults(raw: unknown, defaults: Policy): Policy {
  return fill(isObj(raw) ? raw : {}, defaults as unknown as Obj) as unknown as Policy
}

function fill(raw: Obj, defaults: Obj): Obj {
  const out: Obj = { ...raw }
  for (const [key, def] of Object.entries(defaults)) {
    const cur = raw[key]
    if (isObj(def)) out[key] = fill(isObj(cur) ? cur : {}, def)
    else if (Array.isArray(def)) out[key] = Array.isArray(cur) ? cur : structuredClone(def)
    else out[key] = typeof cur === typeof def ? cur : def
  }
  return out
}
